import { createStore, applyMiddleware } from 'redux';
import { createLogicMiddleware } from 'redux-logic';
/* eslint import/no-extraneous-dependencies: ["error", {"devDependencies": true}] */
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import reducers from './index.reducer';
import logicList from './index.logic';
import requestUtil from '../utils/request';

import environment from '../environment/environment';

const Store = () => {
  const injectedHelpers = { requestUtil };
  const logicMiddleware = createLogicMiddleware(logicList, injectedHelpers);
  const middleware = applyMiddleware(logicMiddleware);

  let store = {};

  if (environment.NODE_ENV === 'production') {
    store = createStore(
      reducers,
      middleware,
    );
  } else {
    store = createStore(
      reducers,
      composeWithDevTools(middleware),
    );
  }

  return store;
};

export default Store();
